import _ from 'lodash';

import { handleErrors } from './ErrorActions';
import { getUserRolesAndRight } from '../api/user-data';

export const FETCH_USER_ROLES_SUCCESS = 'FETCH_USER_ROLES_SUCCESS';
export const FETCH_USER_RIGHTS_SUCCESS = 'FETCH_USER_RIGHTS_SUCCESS';

const fetchUserRolesSuccess = (data) => ({ type: FETCH_USER_ROLES_SUCCESS, payload: data });
const fetchUserRightsSuccess = (data) => ({ type: FETCH_USER_RIGHTS_SUCCESS, payload: data });

export const getUserRolesAndRights = () => async (dispatch, getState) => {
  const { userRoles } = getState();

  try {
    if (_.isNil(userRoles)) {
      return;
    }

    const apiData = await getUserRolesAndRight();
    if (apiData.hasError) {
      dispatch(handleErrors(apiData.errors));
      return;
    }
    dispatch(fetchUserRolesSuccess(apiData.UserRoles));
    dispatch(fetchUserRightsSuccess(apiData.UserRights));
  } catch (error) {
    dispatch(handleErrors(error));
  }
};
